import type { ApprovalFlowInvoiceTypes } from '@weft/api-definition';
import { GetApprovalFlowInvoicesListResponseSchema, type GetApprovalFlowInvoicesListResponse } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useGetApprovalFlowInvoicesList(invoiceTypes: ApprovalFlowInvoiceTypes[], options?: CustomUseQueryOptions<GetApprovalFlowInvoicesListResponse>) {
  return useQuery(
    ['approval-flow-invoices-list', ...invoiceTypes],
    async () => {
      const privateApi = getPrivateApi();
      const stringifiedInvoiceTypes = JSON.stringify(invoiceTypes);

      const approvalFlowInvoicesList = await privateApi.getApprovalFlowInvoicesList({ invoiceTypes: stringifiedInvoiceTypes });

      return GetApprovalFlowInvoicesListResponseSchema.parse(approvalFlowInvoicesList);
    },
    options,
  );
}